"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _EOSApiError = require("../../clients/eos/exceptions/EOSApiError");
var _withErrorRecovery = require("../../services/common/higher-order-functions/with-error-recovery");
var _vehicleHealth = _interopRequireDefault(require("../../services/vehicle-health"));
const useRawVehicleSafetyCampaignsByVin = function (vin, options) {
  const service = (0, _vehicleHealth.default)();
  const query = (0, _reactQuery.useQuery)({
    enabled: !!vin,
    queryKey: ["safety-campaigns-by-vin", vin],
    queryFn: (0, _withErrorRecovery.withErrorRecovery)(async function () {
      if (!vin) return undefined;
      const {
        data
      } = await service.findSafetyCampaigns(vin);
      return data;
    }, function (error) {
      if (!(error instanceof _EOSApiError.EOSApiError)) throw error;
      if (error.status !== _axios.HttpStatusCode.NotFound) throw error;
      // B002 is a known EOS heuristic for no results
      if (error.code !== "B002") throw error;
      return {
        body: {
          data: {
            vehicleCampaignList: []
          }
        }
      };
    }),
    ...options
  });
  return {
    ...query,
    isLoading: query.isLoading && query.fetchStatus !== "idle"
  };
};
var _default = exports.default = useRawVehicleSafetyCampaignsByVin;